import { render, staticRenderFns } from "./VisitPays.vue?vue&type=template&id=35a8410a"
import script from "./VisitPays.vue?vue&type=script&lang=js"
export * from "./VisitPays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports